import { axiosInstance as request } from '@api/rest.service'

/**
 * @description POST /data/subscriptions/import
 * @returns {AxiosPromise<any>}
 */
export const GOOGLE_SHEET_IMPORT_SUBSCRIPTIONS = payload => request.post('/data/subscriptions/import')

/**
 * @description GET /data/spreadsheet-information
 * @returns {AxiosPromise<any>}
 */
export const GOOGLE_SHEET_GET_INFORMATION = () => request.get('/data/spreadsheet-information')
